import React from 'react';

const AppHeader = (props) => {
    return (
        <div className={`u_section-header ${props?.align ? 'u_account-inner__text' : ''}`}>
            <div className="u_border-header u_border-header-center">
                <h1>{props.header}</h1>
            </div>
            {props.title && <p dangerouslySetInnerHTML={{__html: props.title,}}/>}
        </div>
    );
};

export default AppHeader;